import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Helper function to convert picklist array to Formly options format
 */
export function toFormlyOptions(items: Observable<any[]>, valueProp = 'display_value', labelProp = 'display_value') {
  return items.pipe(
    map((list) =>
      list.map((item) => ({
        value: item[valueProp],
        label: item[labelProp],
      }))
    )
  );
}